import { render } from "./ModalCerrarSesion.vue?vue&type=template&id=30797add&scoped=true&ts=true"
import script from "./ModalCerrarSesion.vue?vue&type=script&lang=ts"
export * from "./ModalCerrarSesion.vue?vue&type=script&lang=ts"

import "./ModalCerrarSesion.vue?vue&type=style&index=0&id=30797add&lang=scss&scoped=true"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30797add"]])

export default __exports__